export default "__VITE_ASSET__9f658ca6__"